import { SessionProvider } from 'next-auth/react';

export const ShopifyAuthProvider = ({ initialSession, children }) => (
  <SessionProvider session={initialSession} refetchOnWindowFocus={true}>
    {children}
  </SessionProvider>
);
